import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class CompetitorPlayerStatsModuleTabClickEventModel extends BaseAnalyticsEvent {
  athleteId: Number;
  gameId: Number;
  status: Number;
  clickType: String;

  constructor(params) {
    super('click', 'tab', 'live-stats');

    this.athleteId = params.athleteId;
    this.gameId = params.gameId;
    this.status = params.status;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.athleteId = this.athleteId;
    properties.gameId = this.gameId;
    properties.status = this.status;
    properties.clickType = this.clickType;

    return properties;
  }
}
